// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  padding: 24px;
  font-size: 18px;
  background: #fafafa;
  max-height: calc(100vh - 60px);
  overflow-y: scroll;
}

.dashboard .ant-card-head-title {
  font-size: 24px;
  border-bottom: unset;
}

.dashboard .ant-card,
.dashboard .ant-card-head {
  background: #fafafa;
  box-shadow: none !important;
  border: none !important;
  border-bottom: none !important;
}

.verified-users {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 12px;
}

.verified-icon {
  width: 50px;
  height: 50px;
}

.dashboard-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 24px;
}

.stat-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 30px;
  min-height: 100px;
  color: #252b48;
  font-size: 20px;
  text-align: left;
  line-height: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dashboard-content {
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;
}

.content-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content-card h3 {
  margin-bottom: 8px;
}

.ant-statistic .ant-statistic-title,
.ant-statistic .ant-statistic-content {
  color: #333333;
  font-weight: bold;
  font-size: 18px;
  text-align: center;
}

.ant-statistic .ant-statistic-content {
  font-size: 28px;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;;EAEE,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".dashboard {\r\n  padding: 24px;\r\n  font-size: 18px;\r\n  background: #fafafa;\r\n  max-height: calc(100vh - 60px);\r\n  overflow-y: scroll;\r\n}\r\n\r\n.dashboard .ant-card-head-title {\r\n  font-size: 24px;\r\n  border-bottom: unset;\r\n}\r\n\r\n.dashboard .ant-card,\r\n.dashboard .ant-card-head {\r\n  background: #fafafa;\r\n  box-shadow: none !important;\r\n  border: none !important;\r\n  border-bottom: none !important;\r\n}\r\n\r\n.verified-users {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-evenly;\r\n  gap: 12px;\r\n}\r\n\r\n.verified-icon {\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n\r\n.dashboard-stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  grid-gap: 24px;\r\n}\r\n\r\n.stat-card {\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  padding: 30px;\r\n  min-height: 100px;\r\n  color: #252b48;\r\n  font-size: 20px;\r\n  text-align: left;\r\n  line-height: 1px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.dashboard-content {\r\n  margin-top: 24px;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  grid-gap: 24px;\r\n}\r\n\r\n.content-card {\r\n  background-color: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  padding: 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.content-card h3 {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ant-statistic .ant-statistic-title,\r\n.ant-statistic .ant-statistic-content {\r\n  color: #333333;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  text-align: center;\r\n}\r\n\r\n.ant-statistic .ant-statistic-content {\r\n  font-size: 28px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
